import React, { FC, useState } from 'react';
import css from './TerminalExample.scss';
import { Divider, Text } from '@wix/design-system';
import { DataHooks } from '../../../../../constants/dataHooks';
import { PackageManagerPopoverMenu } from './PackageManagerPopoverMenu';
import { ClonePrompt } from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import { useSingleTemplateData } from '../../../../../hooks/useSingleTemplateData';
import { CopyCodeToClipboard } from '../../../../UtilityComponents/CopyCodeToClipboard';
import { getDisplayPackageManager } from '../../../../../utils/getDisplayPackageManager';
import { useTranslation } from '@wix/wix-i18n-config';

export const TerminalExample: FC = () => {
  const { template } = useSingleTemplateData();
  const clonePrompts = template.clonePrompt;
  const { t } = useTranslation();
  const [selectedClonePrompt, setSelectedClonePrompt] = useState<ClonePrompt>(
    clonePrompts?.[0] || {},
  );
  const hasMultiplePackageManagers = (clonePrompts?.length || 0) > 1;
  const displayPackageManager = getDisplayPackageManager(selectedClonePrompt);
  const commandPrompt = selectedClonePrompt.prompt;
  const valueToClipboard = `${displayPackageManager} ${commandPrompt}`;

  return (
    <div className={css.terminalWrapper}>
      <div className={css.terminalHeader}>
        <Text
          dataHook={DataHooks.TerminalExampleTitle}
          size="small"
          weight="thin"
          className={css.terminalText}
        >
          {t('app.template-page.modal.terminal.title')}
        </Text>
        <div className={css.rightSideHeaderTerminal}>
          {hasMultiplePackageManagers ? (
            <>
              <PackageManagerPopoverMenu
                clonePromptControl={{
                  selectedClonePrompt,
                  setSelectedClonePrompt,
                }}
              />
              <Divider skin="light" direction="vertical" />
            </>
          ) : null}
          <CopyCodeToClipboard
            origin="cli-terminal-example"
            dataHook={DataHooks.TerminalExampleCopyButton}
            valueToCopy={valueToClipboard}
            skin="light"
          />
        </div>
      </div>
      <div className={css.terminalFooter}>
        <Text size="small" className={css.dollarText}>
          $
        </Text>
        <span className={css.lineGap}>
          <Text size="small" className={css.packageManagerPrefix}>
            {displayPackageManager}
          </Text>
          <Text
            dataHook={DataHooks.TerminalExampleClonePrompt}
            light
            size="small"
            className={css.jetBrainsMono}
          >
            &nbsp;{commandPrompt}
          </Text>
        </span>
      </div>
    </div>
  );
};
